<template>
  <div v-if="direction">
    <div class="topbar">
      <div class="brand" @click="$router.back()">&#8249; 门诊方向</div>
      <button class="share-btn" @click="sharePage">分享</button>
    </div>
    <div class="content">
      <div class="card">
        <div :style="{ fontWeight: 700, fontSize: '17px', color: themeColor }">
          {{ direction.name }}
        </div>
        <div class="detail-section-title" v-if="direction.serviceDesc">专家服务</div>
        <div class="detail-section rich-content" v-if="direction.serviceDesc" v-html="sanitizeRichText(direction.serviceDesc)"></div>
        <div class="detail-section-title" v-if="direction.valueDesc">对你价值</div>
        <div class="detail-section rich-content" v-if="direction.valueDesc" v-html="sanitizeRichText(direction.valueDesc)"></div>
      </div>

      <div class="section-title">门诊专家</div>
      <div v-if="!(direction.experts && direction.experts.length)" class="empty">
        暂无坐诊专家
      </div>
      <div
        v-for="e in expertDetails"
        :key="e.id"
        class="card tap"
        @click="$router.push('/expert/' + e.id)"
        v-track="'NRCU004|NRCU004-002|方向详情页点击专家卡片'"
      >
        <div class="expert">
          <img class="avatar" v-if="e.photo" :src="e.photo" />
          <div class="avatar" v-else>{{ e.avatar }}</div>
          <div class="meta">
            <div class="name">
              {{ e.name }}
              <span class="muted" style="font-weight: 400; font-size: 12px">{{
                e.expertLevel === 1 ? "知名专家" : "科研带教"
              }}</span>
            </div>
            <div class="field">{{ e.field }}</div>
          </div>
          <span class="badge">专家介绍/预约</span>
        </div>
      </div>

      <template v-if="slots.length">
        <div class="section-title">本方向可预约号源</div>
        <div
          v-for="s in sortedSlots"
          :key="s.id"
          class="card tap slot-card"
          @click="chooseSlot(s)"
          v-track="'NRCU004|NRCU004-004|方向详情页点击号源'"
        >
          <div class="row">
            <div>
              <div style="font-weight: 600">{{ s.title }}</div>
              <div class="muted">
                {{ expertNameOf(s.expertId) }} ·
                {{ s.slotType === 1 ? "报告交付" : s.durationText + " 分钟 · 电话咨询" }}
              </div>
            </div>
            <div class="slot-action">
              <div class="price">¥{{ (s.price / 100).toLocaleString("zh-CN") }}</div>
              <div class="book-now">立即预约 <span aria-hidden="true">›</span></div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { directionList, expertList, slotList } from "@/api/nrc.js";
import { requireLogin } from "@/utils/requireLogin.js";
import { dirColorByIndex } from "@/utils/dirColor.js";
import { sanitizeRichText } from "@/utils/richText.js";
import { captureReferralVisit, orderReferralToken, shareReferralPage } from "@/utils/referral.js";

export default {
  name: "DirectionDetail",
  data() {
    return {
      direction: null,
      directionIndex: 0,
      expertDetails: [],
      slots: [],
    };
  },
  computed: {
    themeColor() {
      return dirColorByIndex(this.directionIndex).solid;
    },
    // 按号源类型分组显示：报告交付排一起，电话咨询排一起，不再是接口返回的原始散序
    sortedSlots() {
      return [...this.slots].sort((a, b) => a.slotType - b.slotType);
    },
  },
  created() {
    let id = this.$route.params.id;
    captureReferralVisit(2, id, this.$route.query.ref);
    directionList().then((list) => {
      let index = list.findIndex((d) => d.id === id);
      this.directionIndex = index >= 0 ? index : 0;
      this.direction = (index >= 0 ? list[index] : null) || {};
    });
    expertList({ directionId: id }).then((r) => {
      this.expertDetails = r;
    });
    slotList({ directionId: id }).then((r) => {
      this.slots = r;
    });
  },
  methods: {
    sanitizeRichText,
    // 号源卡片上显示"这是哪位专家的"，直接从已经请求过的专家列表里查，不用额外发请求
    expertNameOf(expertId) {
      let expert = this.expertDetails.find((e) => e.id === expertId);
      return expert ? expert.name : "";
    },
    chooseSlot(s) {
      requireLogin(() => {
        let expert = this.expertDetails.find((e) => e.id === s.expertId) || {};
        this.$router.push({
          path: "/order/create",
          query: {
            slotId: s.id,
            title: s.title,
            price: s.price,
            slotType: s.slotType,
            durationText: s.durationText,
            description: s.description,
            expertName: expert.name,
            directionId: s.directionId,
            expertId: s.expertId,
            referralVisitToken: orderReferralToken(s.expertId, s.directionId),
          },
        });
      });
    },
    sharePage() {
      requireLogin(() => shareReferralPage(`/direction/${this.direction.id}`, `推荐门诊：${this.direction.name}`));
    },
  },
};
</script>

<style scoped>
.share-btn{margin-left:auto;border:0;background:transparent;color:#0e7490;font-size:14px}
.slot-card{border:1px solid rgba(14,116,144,.16);box-shadow:0 4px 14px rgba(14,116,144,.1)}
.slot-card:active{background:#f4fbfc;transform:scale(.995)}
.slot-action{flex:0 0 auto;margin-left:14px;text-align:right}
.book-now{margin-top:7px;color:#0e7490;font-size:13px;font-weight:600}
.book-now span{display:inline-block;margin-left:2px;font-size:18px;line-height:12px;vertical-align:-1px}
</style>
